function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M478.8,332.7c15.7-33.7,23.7-72,23.7-113.9c0-4.4-3.6-8-8-8H17.4c-4.4,0-8,3.6-8,8c0,41.9,8,80.2,23.7,113.9   c12.3,26.3,29.1,49.5,50.1,69C72,407.4,64.3,419,64.3,432.4c0,19,15.4,34.4,34.4,34.4H413c19,0,34.4-15.4,34.4-34.4   c0-13.4-7.7-25-18.9-30.7C449.7,382.2,466.5,359,478.8,332.7z M25.5,226.8h460.9c-2.3,89.4-42.7,142.1-77.7,171.2H103.2   C68.3,368.9,27.8,316.2,25.5,226.8z M413.2,450.8H98.8c-10.2,0-18.4-8.3-18.4-18.4c0-10.2,8.3-18.4,18.4-18.4h314.3   c10.2,0,18.4,8.3,18.4,18.4C431.6,442.6,423.3,450.8,413.2,450.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.5,360.6c1.5,1.3,3.4,1.9,5.2,1.9c2.2,0,4.5-0.9,6.1-2.8c2.9-3.3,2.5-8.4-0.8-11.3c-38.5-33.2-45.8-90.1-45.9-90.6   c-0.5-4.4-4.5-7.5-8.9-7s-7.5,4.5-7,8.9C65.5,262.4,73.2,323.3,116.5,360.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.9,149.7c-2.5,3.2-2.3,7.8,0.7,10.7c1.6,1.5,3.6,2.2,5.6,2.2c2.1,0,4.2-0.8,5.8-2.4c8.4-8.7,1.9-20.3-3.9-30.5   c-5.5-9.8-11.7-21-7.9-29.7c1.8-4-0.1-8.8-4.1-10.5c-4-1.8-8.8,0.1-10.5,4.1c-7,16,2,32.2,8.6,44C74.3,141.5,77.6,147.3,77.9,149.7   z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.9,176.1c-2.5,3.2-2.2,7.8,0.7,10.7c1.6,1.5,3.6,2.3,5.6,2.3c2.1,0,4.2-0.8,5.7-2.4c8.4-8.7,1.9-20.2-3.8-30.5   c-5.5-9.8-11.8-21-7.9-29.7c1.8-4-0.1-8.8-4.1-10.5c-4-1.8-8.8,0.1-10.5,4.1c-7.1,16,2,32.2,8.6,44   C129.3,167.9,132.6,173.7,132.9,176.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.3,106.1c-2.5,3.2-2.3,7.8,0.7,10.7c1.6,1.5,3.6,2.2,5.6,2.2c2.1,0,4.2-0.8,5.8-2.4c8.4-8.7,1.9-20.3-3.9-30.5   c-5.5-9.8-11.7-21-7.9-29.7c1.8-4-0.1-8.8-4.1-10.5c-4-1.8-8.8,0.1-10.5,4.1c-7,16,2,32.2,8.6,44C140.7,97.9,144,103.7,144.3,106.1   z"
}));

function SvgNutritionTruthsBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "-50px",
    y: "px",
    viewBox: "-50 0 650 650",
    style: {
      enableBackground: "new -50 0 650 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionTruthsBadge);
export default __webpack_public_path__ + "static/media/NutritionTruthsBadge.a351174d.svg";
export { ForwardRef as ReactComponent };